import api from './api';

const getAgenda = async (schoolYearId, journeyId, educationLevelId, gradeId, courseId, studentId, startDate, endDate) => {
    try {
        const response = await api.get(`/agenda/all?schoolYearId=${schoolYearId}&journeyId=${journeyId}&educationLevelId=${educationLevelId}&gradeId=${gradeId}&courseId=${courseId}&studentId=${studentId}&startDate=${startDate}&endDate=${endDate}`);
        return response.data;
    } catch (error) {
        throw error;
    }
};

const getAgendaById = async (agendaId) => {
    try {
        const response = await api.get(`/agenda/${agendaId}`);
        return response.data;
    } catch (error) {
        throw error;
    }
};


const createEventoAgenda = async (agenda) => {
    try {
        const response = await api.post(`agenda/`, agenda);
        return response.data;
    } catch (error) {
        throw error;
    }
};

const updateAgenda = async (agenda) => {
    try {
        const response = await api.put(`/agenda`, agenda);
        return response.data;
    } catch (error) {
        throw error;
    }
};

const deleteEventoAgendaById = async (id) => {
    try {
        const response = await api.delete(`agenda/${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export default {
    getAgenda,
    getAgendaById,
    updateAgenda,
    createEventoAgenda,
    deleteEventoAgendaById
};